import { tips as headlines, topics } from '../content';
import Journalist from "./journalist";
import Reader from "./reader";
import TurnGraph from "./turnGraph";
export default class GameState {
    constructor() {
        this.END_TURN = 10;
        this.turn = 0;
        this.money = new TurnGraph(0);
        this.activeHeadlines = [];
        this.currentTips = [];
        this.journalists = [
            new Journalist("Jerry", "Southerford"),
            new Journalist("Flynn", "Armory"),
            // new Journalist("Autumn", "Johnson"),
            // new Journalist("Miles", "Mallory"),
        ];
        this.subscribers = [];
        this.lastTurnSubscribers = 0;
        this.rating = 0;
        this.lastTurnRating = 0;
        this.allHeadlines = headlines;
        this.topicInfo = topics;
        this.topicKeys = Object.keys(topics);
        this._prepareNextTurn();
    }
    finishTurn() {
        for (let journalist of this.journalists) {
            const headline = journalist.turn(this.turn);
            if (headline !== null) {
                this.activeHeadlines.push(headline);
            }
        }
        for (let headline of this.activeHeadlines) {
            for (let i = 0; i < (headline.shares.latestChange || 0) * 2; i++)
                this._advertiseHeadline(headline);
            if (headline.writtenOn === this.turn)
                for (let subscriber of this.subscribers)
                    subscriber.read(headline, this);
            let numRandomImpressions = (5 - this.turn + headline.writtenOn) * (Math.random() + 3) * Math.log(this.subscribers.length + 1000) * 10;
            for (let i = 0; i < numRandomImpressions; i++)
                this._advertiseHeadline(headline);
            for (let i = 0; i < headline.advertiseImpressions; i++)
                this._advertiseHeadline(headline, true);
            headline.advertiseImpressions = 0;
            headline.turn(this.turn);
            this.money.add(headline.revenue.latestChange);
        }
        this.money.turn(this.turn);
        if (this.activeHeadlines.length)
            this.rating = this.activeHeadlines.reduce((a, b) => a + b.quality, 0) / this.activeHeadlines.length;
        if (this.money.latest >= 500)
            localStorage.setItem("moneyAchievement", "true");
        if (this.subscribers.length >= 5000)
            localStorage.setItem("subsAchievement", "true");
        if (this.turn >= this.END_TURN && this.rating >= 4)
            localStorage.setItem("ratingAchievement", "true");
    }
    nextTurn() {
        this.turn++;
        this._prepareNextTurn();
    }
    hasMoney(amount) {
        debugger;
        return amount <= this.money.latest + this.money.queue;
    }
    spendMoney(amount) {
        if (!this.hasMoney(amount))
            return false;
        this.money.add(-amount);
        return true;
    }
    startProject(project, journalist) {
        for (let j of this.journalists)
            if (j.currentProject == project)
                j.quitCurrentProject();
        journalist.startProject(project);
    }
    _prepareNextTurn() {
        this.currentTips = this.allHeadlines[this.turn] || [];
        this.lastTurnSubscribers = this.subscribers.length;
        this.lastTurnRating = this.rating;
    }
    _advertiseHeadline(headline, isAdView = false) {
        const reader = new Reader(this);
        reader.read(headline, this, isAdView);
        if (reader.subscribed)
            this.subscribers.push(reader);
    }
}
